var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-settings",
    transform: "translate(3934 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1207",
    "data-name": "Rectangle 1207",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(-3934 530)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "operations-record",
    transform: "translate(-3927.731 535.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M22.5,22.5h6.891v1.378H22.5Z",
    transform: "translate(-7.66 -7.846)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M22.5,27h6.891v1.378H22.5Z",
    transform: "translate(-7.66 -9.59)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    d: "M22.5,31.5h6.891v1.378H22.5Z",
    transform: "translate(-7.66 -11.334)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6914",
    "data-name": "Path 6914",
    d: "M15.385,18.141a2.783,2.783,0,1,1,2.756-2.756h1.378a4.135,4.135,0,1,0-4.135,4.135Z",
    transform: "translate(-3.301 -3.487)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    d: "M21.252,8.482,19.626,5.665a1.377,1.377,0,0,0-1.636-.617l-1.677.568a7.609,7.609,0,0,0-.9-.522l-.347-1.737A1.378,1.378,0,0,0,13.71,2.25H10.457A1.378,1.378,0,0,0,9.106,3.358L8.759,5.093a7.557,7.557,0,0,0-.915.519L6.177,5.049a1.377,1.377,0,0,0-1.634.617L2.916,8.482A1.378,1.378,0,0,0,3.2,10.207l1.33,1.169c-.011.173-.026.345-.026.521s.007.353.02.528L3.2,13.589a1.378,1.378,0,0,0-.285,1.724L4.542,18.13a1.377,1.377,0,0,0,1.636.617l1.677-.568a7.562,7.562,0,0,0,.9.523l.347,1.735a1.378,1.378,0,0,0,1.352,1.107h1.626V20.166H10.457L9.968,17.72a6.267,6.267,0,0,1-1.857-1.083l-2.375.8L4.109,14.624l1.878-1.65a6.151,6.151,0,0,1,0-2.155L4.109,9.171,5.735,6.355l2.361.8A6.223,6.223,0,0,1,9.968,6.075l.489-2.446H13.71L14.2,6.075a6.269,6.269,0,0,1,1.857,1.083l2.375-.8,1.626,2.817L18.13,10.86l.908,1.037,1.929-1.691a1.378,1.378,0,0,0,.285-1.724Z",
    transform: "translate(0 0)",
    fill: "#213364"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.f0963f7188fc2c0f026c44168d5a0601.svg";
export { ForwardRef as ReactComponent };